import {Card, List, ListItemIcon, ListItemText, css, styled} from '@mui/material';
import {StyledCardProps} from './types';

export const StyledCardContainer = styled(Card)<StyledCardProps>`
	justify-content: space-between;
	flex-direction: column;
	padding: ${({$customPadding}) => $customPadding ?? '16px'};
	display: flex;
	gap: ${({$customGap}) => $customGap ?? '16px'};

	${({$borderTop, $borderColor, theme}) =>
		$borderTop &&
		css`
			padding-top: 12px;
			border-top: 4px solid ${$borderColor ?? theme.palette.customInfo.main};
		`}
`;

export const StyledList = styled(List)`
	display: flex;
	gap: 8px;
`;

export const StyledListItemIcon = styled(ListItemIcon)`
	color: ${({theme}) => theme.palette.primary.main};
	margin-right: 8px;
	min-width: unset;
	padding: 2px 0;
	margin-top: 0;
`;

export const StyledListItemText = styled(ListItemText)<StyledCardProps>`
	flex-direction: ${({$flexDirection}) => $flexDirection ?? 'column'};
	display: flex;
	margin: 0;
	gap: ${({$customTypographyGap}) => $customTypographyGap || '4px'};
	${({$mb}) => $mb && `margin-bottom: ${$mb}px;`}
`;
